export default __webpack_public_path__ + "static/media/vc.1d983561.jpg";